const ANALYTICS_EVENT_PARAMS = Object.freeze({
  APP_ENVIRONMENT: "app_environment"
})

const ANALYTICS_USER_PROPERTIES = Object.freeze({
  USER_ROLE: "user_role"
})

export default {
  ANALYTICS_EVENT_PARAMS,
  ANALYTICS_USER_PROPERTIES
}
